import { Component, OnInit } from '@angular/core';
import { IGeosegment, MarketingRepositoryService } from '@/app/services/repositories/marketing-repository.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ViewGeofenceModalComponent } from '../../modals/view-geofence-modal/view-geofence-modal.component';
import { SessionService } from '@/app/core/auth/session.service';
import { PopupsService } from '@/app/services/popups.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-your-geofences-page',
  templateUrl: './your-geofences-page.component.html',
  styleUrls: ['./your-geofences-page.component.scss'],
})
export class YourGeoFencesPageComponent implements OnInit {
  geofences: IGeosegment[] = [];
  displayedColumns = ['name', 'radius', 'actions'];

  viewGeoModalConfig: MatDialogConfig = new MatDialogConfig();

  loading = false;

  constructor(
    private marketingService: MarketingRepositoryService,
    private currentUser: SessionService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private popups: PopupsService
  ) {
    this.viewGeoModalConfig.width = '600px';
  }

  get currentAdminGroupId() {
    return this.currentUser.currentAdminGroup.groupId;
  }

  ngOnInit() {
    this.getGeofences();
    this.currentUser.currentAdminGroup$.pipe(untilDestroyed(this)).subscribe(() => {
      this.getGeofences();
    });
  }

  getGeofences() {
    this.loading = true;
    this.marketingService
      .getGeosegments({
        groupId: this.currentAdminGroupId,
      })
      .subscribe(
        (result) => {
          this.loading = false;
          this.geofences = result.results.reverse();
        },
        () => {
          this.loading = false;
        }
      );
  }

  viewGeoFence(fence: IGeosegment) {
    this.viewGeoModalConfig.data = fence;
    this.dialog.open(ViewGeofenceModalComponent, this.viewGeoModalConfig);
  }

  deleteGeoFence(fence: IGeosegment) {
    this.marketingService.deleteGeosegment(fence.id).subscribe(
      () => {
        this.toastr.success('Geofence deleted.');
        this.deleteRowFromTable(fence);
      },
      () => this.toastr.error('Failed to delete geofence.')
    );
  }

  deleteRowFromTable(fence: IGeosegment) {
    const itemIndex = this.geofences.findIndex((obj) => obj.id === fence.id);
    this.geofences.splice(itemIndex, 1);
    // https://stackoverflow.com/questions/48991210/angular-material-mat-table-data-not-refreshed-from-parent-changes?rq=1
    // https://stackoverflow.com/questions/7486085/copying-array-by-value-in-javascript
    this.geofences = this.geofences.slice();
  }

  async openConfirmationDialog(fence: IGeosegment) {
    if (await this.popups.confirm('Are you sure you want to delete this?')) {
      this.deleteGeoFence(fence);
    }
  }
}
